import React from 'react'
import { SubscriptionUserPurchasesTable } from '../subscription-user-purchases-table'

export const SubscriptionUserPurchasesTab = (props: any) => {
  const { id } = props
  return {
    name: 'Subscriptions',
    path: `/people/users/${id}/subscriptions`,
    component: () => <SubscriptionUserPurchasesTable userId={Number(id)} />,
  }
}
